import { Avatar } from "../../../avatar.component";
import cx from "classnames";
import TurndownService from "turndown";
import ErrorBoundary from "../../../error-boundry.component";
import { Suspense, useEffect, useState } from "react";
import RichTextEditor from "../../../form-controls/rich-text-editor.component";
import { SendButton } from "../../../molecule/send-button";
import { ActionModal } from "../../../action-modal.component";
import { MentionService } from "../../../../_service/mention.service";
import { PostService } from "../../../../_service";
import checkForProfanity from "../../../../_utils/restricted-words";
const tds = new TurndownService();

export default function EditCommentComponent({
    post,
    comment,
    reply,
    user,
    isSubComment = false,
    commentId,
    replyId,
    community,
    addToast,
    setEditComment = (e) => { },
    setEditCommentReply = (e) => { },
    updatePost = (e) => { }
}) {
    const [description, setDescription] = useState(
        (isSubComment ? reply.description : comment.description) || ""
    );
    const [isPosting, setIsPosting] = useState(false);
    const [profanityWords, setProfanityWords] = useState([]);

    useEffect(() => {
        if (post.latestComment?.description) {
            setDescription(post.latestComment.description);
        }
    }, [post]);

    async function onSubmit() {
        if (!description) {
            return window.alert("Comment text is required!");
        }

        const restrictedWords = await checkForProfanity(description);
        if (restrictedWords.length > 0) {
            setProfanityWords(restrictedWords);
            return;
        }

        setIsPosting(true);
        if (!isSubComment) {
            const embedlessSubComment = description.replace(
                /(?:<figure class="media"><oembed url=")([^"^<^>^\[^\]]+)(?:"><\/oembed><\/figure>)/g,
                " $1 "
            );
            let finalComment = await tds.turndown(embedlessSubComment);

            try {
                const response = await PostService.updateComment(
                    user,
                    finalComment,
                    post.id,
                    commentId
                );

                setDescription(response.comment.description);

                PostService.getPostDetail(user, post.id)
                    .then((response) => {
                        const updatedPost = { ...response.post };
                        const updatedComment = updatedPost.comments.find(comment => comment.id === commentId);
                        updatePost({ ...updatedComment, description: finalComment });
                    })
                    .catch((error) => [
                        window.alert("Error Updating Comment:", error)
                    ])

                setIsPosting(false);
                setEditComment(false);
                addToast("Comment Updated");
            } catch (error) {
                setIsPosting(false);
            }
        } else {
            const embedlessSubComment = description.replace(
                /(?:<figure class="media"><oembed url=")([^"^<^>^\[^\]]+)(?:"><\/oembed><\/figure>)/g,
                " $1 "
            );
            let finalReply = await tds.turndown(embedlessSubComment);

            try {
                const response = await PostService.updateReply(
                    user,
                    finalReply,
                    post.id,
                    commentId,
                    reply.id
                );

                setDescription(response.reply.description);

                PostService.getPostDetail(user, post.id)
                    .then((response) => {
                        const updatedReply = response.post.comments
                            .flatMap(comment => comment.replies)
                            .find(reply => reply.id === replyId);
                        updatePost({ ...updatedReply, description: finalReply });
                    })
                    .catch((error) => [
                        window.alert("Error Updating Reply:", error)
                    ])

                setIsPosting(false);
                setEditCommentReply(false);
                addToast("Reply Updated");
            } catch (error) {
                setIsPosting(false);
            }
        }
    }
    return (
        <ErrorBoundary>
            <div className="flex py-2">
                <div>
                    <Avatar
                        user={user}
                        hideNameOnMobile
                        noName
                        size={36}
                        className="cursor-pointer"
                    />
                </div>
                <div
                    className={cx(
                        "flex w-full flex-col items-start rounded-xl border border-border px-4 py-2",
                        {
                            "": !isSubComment,
                            "bg-card": isSubComment,
                        }
                    )}>
                    <div className="flex w-full items-center justify-between">


                        <Suspense fallback={<></>}>
                            <RichTextEditor
                                className="noBorder minHeightDefault w-full overflow-y-auto text-sm text-secondary-foreground"
                                text={isSubComment ? reply.description : comment.description}
                                setText={setDescription}
                                placeholder={isSubComment ? "Write Reply..." : "Write Comment..."}
                                getMentionsFeed={async (query) => {
                                    const users = (
                                        await MentionService.searchInCommunity(
                                            user,
                                            community.id,
                                            query
                                        )
                                    ).users.map((user, index) => {
                                        const useruid = user.id;
                                        user.id = "@" + user.userId;
                                        user.userId = useruid;
                                        return user;
                                    });
                                    return users;
                                }}
                            />
                        </Suspense>


                        <SendButton
                            onClick={onSubmit}
                            disabled={!description}
                            isLoading={isPosting}
                        />
                    </div>
                </div>

                <ActionModal
                    active={profanityWords.length > 0}
                    header="Message"
                    buttons={[
                        {
                            label: "OK",
                            type: "primary",
                            onClick: () => {
                                setProfanityWords([]);
                            },
                        },
                    ]}
                    children={
                        <div className="flex flex-col px-4 pb-4">
                            <p className="font-bold">
                                The following links are restricted and cannot be used in the
                                comment
                            </p>
                            <ul className="ml-4 list-decimal">
                                {profanityWords.map((word) => (
                                    <li key={word} className="text-secondary-foreground/80 text-sm">
                                        {word}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    }
                    setActive={(e) => {
                        setProfanityWords([]);
                    }}
                    onSubmit={() => {
                        setProfanityWords([]);
                    }}
                />
            </div>
        </ErrorBoundary>
    )
}
